import '@/styles/globals.css'
import '@/styles/typography.css'
import '@helix-ds/react/styles.css'
import '@helix-ds/tokens/css'
import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initializeSentry } from './sentry.config'

initializeSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => (
          <div className="flex min-h-screen items-center justify-center bg-gray-50">
            <div className="rounded-lg bg-white p-8 text-center shadow-lg">
              <h1 className="mb-4 text-2xl font-bold text-red-600">Something went wrong</h1>
              <p className="mb-4 text-gray-600">
                {error instanceof Error ? error.message : 'Please refresh the page to try again.'}
              </p>
              <div className="flex justify-center gap-4">
                <button onClick={resetError} className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600">
                  Try again
                </button>
                <button
                  onClick={() => window.location.reload()}
                  className="rounded bg-gray-500 px-4 py-2 text-white hover:bg-gray-600"
                >
                  Refresh page
                </button>
              </div>
            </div>
          </div>
        )}
        showDialog
      >
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
)
